import React, { useState, useEffect } from 'react';

import { motion } from 'framer-motion';

// import { images } from '../../constants';

import { urlFor, client } from '../../client';

import { AppWrap, MotionWrap } from '../../wrapper';


import './about.scss';

// const abouts = [
//   {
//     title: 'Front-end',
//     description: 'Front-end developer using React and Next',
//     imgUrl: images.about01,
//   },
//   {
//     title: 'Back-end',
//     description: 'Back-end developer using React and Next',
//     imgUrl: images.about02,
//   },
//   {
//     title: 'Full stack',
//     description:
//       'Full stack developer using React and Next Full stack developer using React and Next',
//     imgUrl: images.about03,
//   },
//   {
//     title: 'Front-end',
//     description: 'Front-end developer using React and Next',
//     imgUrl: images.about04,
//   },
// ];

const About = () => {
  const [abouts, setAbouts] = useState([]);

  useEffect(() => {
    const query = '*[_type == "abouts"]';

    client.fetch(query).then((data) => {
      setAbouts(data);
    });
  }, []);

  return (
    <div className='app__about'>
      <h2 className='head-text'>
        I Know that <span>Good Development</span>
        <br />
        means <span>Good Business</span>
      </h2>
      <div className='app__profiles'>
        {abouts.map((about, index) => (
          <motion.div
            className='app__profile-item'
            key={about.title + index}
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: 'tween' }}>
            <img src={urlFor(about.imgUrl)} alt={about.title} />
            <h2 className='bold-text' style={{ marginTop: 20 }}>
              {about.title}
            </h2>
            <p className='p-text' style={{ marginTop: 10 }}>
              {about.description}
            </p>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default AppWrap(
  MotionWrap(About, 'app__about'),
  'about',
  'app__whitebg'
);
